import React from 'react';
import ExtendedModulePage from './ExtendedModulePage';
export default function FeeMasterPage(){ return <ExtendedModulePage moduleKey="fee-masters"/>; }
